export enum STORAGE {
  TRACE_ID_KEY = "__TRACE_ID__",
  PLATFORM = "platform",
  LANGUAGE_FLAG = "languageFlag",
  USER_ID = "userId",
  USER_KEY = "userKey",
  LOGIN_TYPE = "loginType",
  DOMAIN = "domain",
  RAY_SYNC_USER_KEY = "raySyncUserKey",
  TASK_ID = "taskIds",
  TOGGLE_FLAG = "toggleFlag",
  HIDDEN_SETTING_INTRO_TASKS = "hiddenSettingIntroTasks",
  IS_CLIEND_DOWNLOADED_KEY = "isClientDownloaded",
  PUSH_INFORMATION = "pushInformation",
  CLICKED_TO_LOGIN = "clickedToLogin",
  ROUTE_CHANGE = "_routechange",
  LOADING_CHUNK = "LoadingChunk",
  SHOW_COLUMNS = "showedColumns",
  PLUGIN_NAME = "pluginName",
  ACCOUNT = "account",
  PASSWORD = "password",
  TOKEN = "token",
  HANKEY_DEMAND_FLAG = "hankeyDemandFlag",
  HAS_SHOW_TURN_TABLE = "hasShowTurnTable",
  EVENT_FLAG = "eventFlag",
  TREE_PATH = "treePath",
  KNEW_FILE_ATTENTION_FLAG = "knewFileAttentionFlag",
  ACKNOWLEDGEMENT = "acknowledgement",
  UID = "uid",
  PRE_USER_ID = "preUserId",
  COME_FROM = "comefrom",
  BLOCK_COME_FROM = "blockComefrom",
  CONSUMPTION_CUSTOM_ROW = "consumptionCustomRow",
  BUSINESS_TYPE = "biz",
  ACCESS_ID = "accessId",
  RAYVISION_USERKEY = "rayvision_userKey",
  CUSTOM = "custom",
  SORT_COLUMNS = "_sort_columns",
  NETWORK_ERROR = "network_error",
  USER_NETWORK_ERROR = "user_network_error",
  TOPUP_CARD_INFO = "topup_card_info",
  TOPUP_CHECKED_CARD = "topop_checked_card",
  HIDE_VERIFY_DIALOG = "hide_verify_dialog",
  HIDE_STORAGE_DIALOG = "hide_storage_dialog",
  IS_ACTIVITY_DEFAULT_MEMBER = "is_activity_default_member",
  PicturePlatforms = "PicturePlatforms",
  CPUPlatforms = "CPUPlatforms",
  GPUPlatforms = "GPUPlatforms",
  QYPlatforms = "QYPlatforms",
  SWITCH_RAYSYNC = "switch_raysync",
  ACKNOWLEDGE_ANIMATION_GIFT = "acknowledage_animation_gift",
  SHOW_USING_GUIDE = "show_using_guide",
  SHOW_USING_GUIDE_ACKNOWLEDGE = "show_using_guide_acknowledge",
  CURRENT_Click_AIPlatform = "currentClickAIPlatform",
  EVER_LOGIN_AI_RAYSYNC = "ever_login_ai_raysync",
  CURRENT_Click_Platform = "currentClickPlatform",
  SOME_SPEED_UP_TASK = "some_speed_up_task",
  SPEED_UP_PLATFORM = "speed_up_platform",
  WElFARE_TODAY_IS_REMIND = "WElFARE_TODAY_IS_REMIND",
  WElFARE_REMIND_TIMESTAMP = "WElFARE_REMIND_TIMESTAMP",
  USER_BUSINESS_TYPE = "user_business_type",
}
